import { render, staticRenderFns } from "./coursePlay.vue?vue&type=template&id=8d3fe824&"
import script from "./coursePlay.vue?vue&type=script&lang=js&"
export * from "./coursePlay.vue?vue&type=script&lang=js&"
import style0 from "./coursePlay.vue?vue&type=style&index=0&id=8d3fe824&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports